import { geoDist } from './geo';
import { useEffect, useState } from 'react';

// auto-hide map tools while the user is walking (GPS speed), show again when standing
const K = 'giss_walk_hide';
export const walkHideOn = () => localStorage.getItem(K) !== '0';
const setWalking = (v) => document.body.classList.toggle('user-walking', v);
let last = null, fast = 0, snooze = 0, tm = null;

export function setWalkHide(on) {
  localStorage.setItem(K, on ? '1' : '0');
  if (!on) setWalking(false);
  window.dispatchEvent(new Event('giss-walk'));
}

export function useWalkHide() {
  const [v, setV] = useState(walkHideOn);
  useEffect(() => { const on = () => setV(walkHideOn()); window.addEventListener('giss-walk', on); return () => window.removeEventListener('giss-walk', on); }, []);
  return v;
}

const dist = (a, b) => geoDist([a.lat, a.lon], [b.lat, b.lon]);

// speed in m/s: device speed, else derived from the last fix (only with good accuracy)
export function feedWalk(pos) {
  if (!walkHideOn()) return;
  const c = pos.coords, p = { lat: c.latitude, lon: c.longitude, t: pos.timestamp || Date.now() };
  let v = c.speed;
  if ((v == null || Number.isNaN(v)) && last && c.accuracy <= 15 && p.t > last.t) v = dist(last, p) / ((p.t - last.t) / 1000);
  last = p;
  if (v == null || Number.isNaN(v)) return;
  fast = v > 0.7 ? fast + 1 : 0;
  if (fast >= 2 && Date.now() > snooze) {
    setWalking(true);
    clearTimeout(tm);
    tm = setTimeout(() => setWalking(false), 5000);
  }
}

export const snoozeWalk = () => { snooze = Date.now() + 60000; fast = 0; setWalking(false); };
